import React from "react";

import { ActiveUtterancesContextType } from "./ScrollManagerContext.decl";

export const ActiveUtterancesContext =
  React.createContext<ActiveUtterancesContextType>([]);
